import React, { useRef } from "react";
import { CpDropdown, CpButton } from "@components";
import type { CpDropdownRef } from "../../../components/cp-dropdown/cp-dropdown.component";
import styles from "./filter-header.styles.css";
import { SortFilter } from "../filters";
import { ColumnSchema, FilterControl } from "../types";

type FilterHeaderProps = {
  columnSchema: ColumnSchema;
  filterControl: FilterControl;
};

export function FilterHeader({
  columnSchema,
  filterControl,
}: FilterHeaderProps) {
  const { label, filter } = columnSchema;
  const dropdownRef = useRef<CpDropdownRef>(null);
  const FilterComponent = filter !== false ? filter.component : SortFilter;
  const dropdownWidth =
    filter !== false ? (filter.component.dropdownWidth ?? 300) : 300;

  return (
    <div className="cp-flex-center cp-ellipsis">
      <div className={`cp-ellipsis ${styles.label}`}>{label}</div>
      <CpDropdown
        ref={dropdownRef}
        allowContentClicks
        contentWidth={dropdownWidth}
        renderWhenClosed={false}
        renderTrigger={({ toggle }) => (
          <CpButton
            small
            btnType="icon"
            icon="caret-small-down"
            onClick={toggle}
            className="cp-ml-8 shrink-0"
            aria-label={`Filter ${label}`}
          />
        )}
        renderContent={({ close }) => (
          <FilterComponent
            columnSchema={columnSchema}
            onClose={close}
            filterControl={filterControl}
            {...(filter !== false ? filter.props : {})}
          />
        )}
      />
    </div>
  );
}
